import { render, staticRenderFns } from "./BottomSection.vue?vue&type=template&id=2a9661cc&scoped=true"
import script from "./BottomSection.vue?vue&type=script&lang=js"
export * from "./BottomSection.vue?vue&type=script&lang=js"
import style0 from "./BottomSection.vue?vue&type=style&index=0&id=2a9661cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9661cc",
  null
  
)

export default component.exports